import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { CategoryService } from '@app/core/products/services/category.service';

@Component({
  selector: 'filter-category',
  templateUrl: './filter-category.component.html',
  styleUrls: ['./filter-category.component.scss'],
})
export class FilterCategoryComponent implements OnInit {
  constructor(public categoryService :CategoryService) {}

  @Input() value :number[];
  @Input() label :string;
  @Output() changeCategory :EventEmitter<number[]> = new EventEmitter<number[]>();

  ngOnInit() :void {
    this.categoryService.getProductCategories();
  }

  onChange() {
    this.changeCategory.emit(this.value);
  }
}
